export default "__VITE_ASSET__Do2to9nH__"